// @flow
import React from 'react';
import { Link } from 'react-router-dom';

// return a link or a span
type Props = {
    condition: boolean,
    to: string,
    children: any,
    domProps?: any,
};

const ConditionalLink = ({ condition, to, children, ...domProps }: Props) => {
    if (!condition) {
        return <span {...domProps}>{children}</span>;
    }
    return (
        <Link to={to} {...domProps}>
            {children}
        </Link>
    );
};

export default ConditionalLink;
